/* eslint @ngrx/prefer-effect-callback-in-block-statement: off */
import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, tap } from 'rxjs';

import { DataLayerKeys } from '@ninety/platform/models/analytics/google-analytics/data-layer';
import { DataLayerEvent } from '@ninety/platform/models/analytics/google-analytics/data-layer-event';
import { DataLayerService } from '@ninety/platform/services/services/google-analytics/data-layer.service';
import { ErrorTagService } from '@ninety/platform/services/services/google-analytics/error-tag.service';

import { dataLayerActions } from './data-layer.actions';

@Injectable()
export class DataLayerEffects {
  private actions$ = inject(Actions);
  private dataLayerService = inject(DataLayerService);
  private errorTagService = inject(ErrorTagService);

  /** Bridges `ErrorTagService.trackError()` to the data-layer push action (services -> state inversion). */
  trackError$ = createEffect(() =>
    this.errorTagService.errorTagged$.pipe(
      map(({ message, event }) => dataLayerActions.push({ fields: { event, [DataLayerKeys.errorMessage]: message } }))
    )
  );

  push$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(dataLayerActions.push),
        tap(({ fields }) => this.dataLayerService.push(fields))
      ),
    { dispatch: false }
  );

  dataLayerTrackClick$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(dataLayerActions.trackClick),
        tap(({ event, clickUrl }) => this.dataLayerService.trackClick(event?.target as HTMLElement, { clickUrl }))
      ),
    { dispatch: false }
  );

  dataLayerCreateCompanyEvent$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(dataLayerActions.createCompany),
        tap(({ event }) =>
          this.dataLayerService.push({
            [DataLayerKeys.event]: DataLayerEvent.companyCreate,
            ...this.dataLayerService.getFormMeta(event),
            ...this.dataLayerService.getUrlMeta(new URL(location.href)),
          })
        )
      ),
    { dispatch: false }
  );

  dataLayerTrackFormSubmit = createEffect(
    () =>
      this.actions$.pipe(
        ofType(dataLayerActions.trackFormSubmit),
        tap(({ event }) => this.dataLayerService.trackFormSubmit(event))
      ),
    { dispatch: false }
  );
}
